import React, { createContext } from 'react';

const baseContext = createContext({});

export { baseContext };
